export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9486.ae2af8e8.jpg";